import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
export type OnFeatureFlagChangedSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type OnFeatureFlagChangedSubscription = { __typename?: 'Subscription', onFeatureFlagChanged: { __typename?: 'FeatureFlagChangedEvent', name: Types.FeatureFlagName, changedTenantIds?: Array<string> | null } };


export const OnFeatureFlagChangedDocument = new TypedDocumentString(`
    subscription OnFeatureFlagChanged {
  onFeatureFlagChanged {
    name
    changedTenantIds
  }
}
    `);
